import { fetchRequest } from './apiHelper';
export const queryResult = (job_id, apiServer, setResult) => {
  const url = `${apiServer}/smr_results/${job_id}.json`;

  fetchRequest(url)
    .then((data) => {
      if (data.status === 'pending') {
        setResult(data);
        setTimeout(() => queryResult(job_id, apiServer, setResult), 1000);
        return;
      }

      if (data.status === 'completed') {
        let parsed;
        try {
          parsed = JSON.parse(data.result);
        } catch {
          setResult({
            status: 'error',
            error_message: 'Failed to parse result JSON.',
          });
          return;
        }

        const score = parsed.calculated_score;
        if (typeof score === 'number' && !isNaN(score)) {
          const roundedRank = Math.floor(score * 10) / 10;
          const finalRank =
            score - roundedRank >= 0.05 ? roundedRank + 0.1 : roundedRank;

          setResult({
            status: 'completed',
            calculated_score: finalRank,
            score_type: parsed.score_type,
            risk_1yr_mortality: parsed.risk_1yr_mortality,
            risk_1yr_mortality_or_nyha_ge_iii:
              parsed.risk_1yr_mortality_or_nyha_ge_iii,
            risk_1yr_mortality_or_nyha_iv: parsed.risk_1yr_mortality_or_nyha_iv,
          });
        } else {
          setResult({
            status: 'error',
            error_message:
              parsed.error_message || 'Invalid calculated_score value',
          });
        }
        return;
      }
      setResult(data);
    })
    .catch((err) => {
      setResult({
        status: 'error',
        error_message: err.message || 'Fetch failed',
      });
    });
};
